import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../_services/user.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private _router: Router, private _userService: UserService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    const currentUser = JSON.parse(localStorage.getItem('CURRENT_USER'));
    if (currentUser && currentUser.token && currentUser.fullName) {
      if (
        state.url.includes('scrape-pdf') ||
        state.url.includes('pdf-parser') ||
        state.url.includes('plans') ||
        state.url.includes('test') ||
        state.url.includes('providers') ||
        state.url.includes('reports') ||
        state.url.includes('electricity-plan-parser') ||
        state.url.includes('customer') ||
        state.url.includes('portal')
      ) {
        return true;
      }

      if (currentUser.type === 0) {
        // admin is supreme and can roam anywhere
        return true;
      }

      if (state.url === '/negotiator' && currentUser.type === 4) {
        return true;
      } else if (state.url === '/csr' && currentUser.type === 2) {
        return true;
      } else if (state.url === '/login' || state.url === '/index') {
        this._router.navigate(['/portal/dashboard']);
      } else {
        this._router.navigate(['/login']);
      }
    } else if (state.url === '/login') {
      return true;
    } else {
      this._router.navigate(['/login']);
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/_guards/auth.guard.ts